import {
    ViewFactory,
    ComponentManager,
} from 'radpresentation.htmlclient.defaultviewextensions';
import EditPropertyGroupViewViewModel from '@/ViewModels/Views/EditPropertyGroupViewViewModel';
import EditPropertyGroupView from '@/Views/EditPropertyGroupView';
class EditPropertyGroupViewFactory extends ViewFactory {
    public viewModel: EditPropertyGroupViewViewModel;
    public view: EditPropertyGroupView;

    constructor(private params: any) {
        super(params);
    }

    public getRegion(): string {
        return 'Modal';
    }

    public getView(): JQuery<HTMLElement> {
        if (!this.viewModel) {
            this.viewModel = new EditPropertyGroupViewViewModel({
                callback: this.params.callback,
                currentParentGroup: this.params.currentParentGroup,
                parentGroupData: this.params.parentGroupData,
                propertyGruppenData: this.params.propertyGruppenData,
                selectedGroupPdoId: this.params.selectedGroupPdoId,
                isVisible: this.params.isVisible,
                uiGenerator: this.params.uiGenerator,
                locator: this.params.locator,
                viewFactory: this,
            });
        }

        if (!this.view) {
            this.view = new EditPropertyGroupView(
                this.viewModel,
                this.createRootElement('EditPropertyGroupView')
            );
        }

        return this.view.getTuple().view;
    }
}

export default EditPropertyGroupViewFactory;
ComponentManager.setFactory(
    'EditPropertyGroup',
    EditPropertyGroupViewFactory,
    'RADExtensionManagerHTMLViewExtension'
);
